// MSAL configuration. Auth Code + PKCE via @azure/msal-browser, sessionStorage
// cache (cleared on tab close), loginRedirect (not popup so we don't need
// extra COOP/COEP headers). Required VITE_* env vars are validated at module
// load — missing values throw immediately so misconfiguration is loud.
import { LogLevel, type Configuration } from "@azure/msal-browser";

function requireEnv(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `[msal] ${name} is not set. Set the VITE_* env var at build time.`,
    );
  }
  return value;
}

export const msalConfig: Configuration = {
  auth: {
    clientId: requireEnv(
      "VITE_MSAL_CLIENT_ID",
      import.meta.env.VITE_MSAL_CLIENT_ID,
    ),
    authority: requireEnv(
      "VITE_MSAL_AUTHORITY",
      import.meta.env.VITE_MSAL_AUTHORITY,
    ),
    redirectUri: requireEnv(
      "VITE_MSAL_REDIRECT_URI",
      import.meta.env.VITE_MSAL_REDIRECT_URI,
    ),
    postLogoutRedirectUri: import.meta.env.VITE_MSAL_REDIRECT_URI,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback(level, message) {
        if (level === LogLevel.Error) console.error("[msal]", message);
        else if (level === LogLevel.Warning) console.warn("[msal]", message);
      },
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

export const apiScopes = [
  requireEnv("VITE_API_SCOPE", import.meta.env.VITE_API_SCOPE),
];

export const loginRequest = {
  scopes: apiScopes,
};
